<template>
	<v-card id="feature-items" class="elevation-0" outlined tile>
		<div class="d-block px-4 py-5">
			<v-expansion-panels tile multiple accordion v-model="panel" class="accordion-filter" v-if="sellerData">
				<template v-for="(item, idx) in items">
					<template v-if="item.children.length === 0">
						<template v-if="item.access.includes('general')">
							<template v-if="item.title == 'Pesanan'">
								<template v-if="sellerData.store_is_dropshipper == 'Ya'">
									<a :href="item.to" class="font-weight-bold text-body-2 px-2 feature-title single-link" :class="{'active': activeUrl == item.to }" :key="idx">
										<v-img width="10" :src="item.icon"></v-img>
										{{ item.title }}
									</a>
								</template>
								
								<template v-if="sellerData.store_is_dropship == 'Ya' && sellerData.store_is_seller == 'Ya'">
									<a :href="item.to" class="font-weight-bold text-body-2 px-2 feature-title single-link" :class="{'active': activeUrl == item.to }" :key="idx">
										<v-img width="10" :src="item.icon"></v-img>
										{{ item.title }}
									</a>
								</template>
							</template>

							<template v-else>
								<a :href="item.to" class="font-weight-bold text-body-2 px-2 feature-title single-link" :class="{'active': activeUrl == item.to }" :key="idx">
									<v-img width="10" :src="item.icon"></v-img>
									<template v-if="item.title == 'Inbox' && filterUnreadMsg(sellerAllMessage.lists).length > 0">
										<div class="d-flex align-center flex-row align-start">
											{{ item.title }}
											<v-chip
												class="ma-2"
												color="red"
												x-small
												text-color="white"
											>
												{{ (sellerAllMessage.lists.length > 20) ? '20+' : filterUnreadMsg(sellerAllMessage.lists).length}}
											</v-chip>
										</div>
									</template>
									<template v-else>{{ item.title }}</template>
								</a>
							</template>
						</template>

						<template v-if="item.access.includes(userType)">
							<a :href="item.to" class="font-weight-bold text-body-2 px-2 feature-title single-link" :class="{'active': activeUrl == item.to }" :key="idx">
								<v-img width="10" :src="item.icon"></v-img>
								{{ item.title }}
							</a>
						</template>
					</template>

					<template v-else>
						<v-expansion-panel class="py-3" :key="idx" v-if="item.access.includes('general') || item.access.includes(userType)">
							<v-expansion-panel-header class="font-weight-bold text-body-2 px-2 feature-title">
								<v-img width="10" :src="item.icon"></v-img>
								{{ item.title }}
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-list class="py-2">
									<template v-for="(sub, ids) in item.children">
										<a :href="sub.to" class="text-deco black--text" :class="{'active': activeUrl == sub.to }" :key="ids" v-if="sub.show">
											<v-list-item dense class="px-2 py-1 feature-item">
												<v-list-item-title>
													{{ sub.title }}
												</v-list-item-title>
											</v-list-item>
										</a>
									</template>
								</v-list>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</template>
				</template>
			</v-expansion-panels>
		</div>
	</v-card>
</template>

<script>
import { mapState, mapActions } from "vuex"
// import auth from '@/helpers/auth';

// const isStockist = () => {
// 	const user = auth.getsellerData()
// 	if (user.user_is_stockist.toLowerCase() === 'true') {
// 		return true
// 	} else {
// 		return false
// 	}
// };
export default {
	name: 'SellerSidebar',
	data: () => ({
		showMorecategory: false,
		panel: [],
		activeUrl: '',
		userType: ''
	}),

	computed: {
		...mapState('authSeller', ['isAuth', 'sellerData']),
		...mapState('messages', ['sellerAllMessage']),

		items () {
			let items = [
			{
				icon: '/assets/seller/dashboard.svg',
				title: 'Dashboard',
				to: '/seller/dashboard',
				access: ['general'],
				children: []
			},
			{
				icon: '/assets/seller/voucher.svg',
				title: 'Voucher',
				to: '/seller/voucher',
				access: ['general'],
				children: []
			},
			{
				icon: '/assets/seller/pesanan.svg',
				title: 'Pesanan',
				to: '/seller/pesanan-saya',
				access: ['general', 'seller'],
				children: []
			},
			{
				icon: '/assets/seller/pesanan.svg',
				title: 'Pesanan Dropship',
				to: '/seller/pesanan-dropship',
				access: ['dropshipper', 'seller'],
				children: [
					{
						title: 'Pesanan Dropship',
						to: '/seller/pesanan-dropship',
						show: true,
					},
					// {
					// 	title: 'Klaim Pesanan',
					// 	to: '/seller/klaim-pesanan',
					// 	show: true,
					// }
				]
			},
			{
				icon: '/assets/seller/pesanan.svg',
				title: 'Pesanan Dropshipper',
				to: '/seller/pesanan-dropshipper',
				access: ['dropship'],
				children: [
					{
						title: 'Pesanan Dropshipper',
						to: '/seller/pesanan-dropshipper',
						show: true,
					},
					// {
					// 	title: 'Klaim Pesanan',
					// 	to: '/seller/klaim-pesanan',
					// 	show: true,
					// }
				]
			},
			{
				icon: '/assets/seller/produk.svg',
				title: 'Produk',
				to: '/seller',
				access: ['general'],
				children: [
					{
						title: 'Produk Saya',
						to: '/seller/produk-saya',
						show: true,
					},
					{
						title: 'Tambah Produk Baru',
						to: '/seller/tambah-produk',
						show: true,
					}
				]
			},
			{
				icon: '/assets/seller/stokis.svg',
				title: 'Dropship Saya',
				to: '/seller',
				access: ['dropshipper', 'seller'],
				children: [
					{
						title: 'Daftar Dropship',
						to: '/seller/list-dropship',
						show: true,
					},
					{
						title: 'Tambah Dropship Baru',
						to: '/seller/tambah-dropship',
						show: true,
					},
					// {
					// 	title: 'Request Order',
					// 	to: '/seller/request-order',
					// 	show: true,
					// },
					// {
					// 	title: 'Klaim Order',
					// 	to: '/seller/klaim-order',
					// 	show: true,
					// }
				]
			},
			{
				icon: '/assets/seller/stokis.svg',
				title: 'Dropshipper Saya',
				to: '/seller',
				access: ['dropship'],
				children: [
					{
						title: 'Daftar Dropshipper',
						to: '/seller/list-dropshipper',
						show: true,
					},
					// {
					// 	title: 'Tambah Stokis Baru',
					// 	to: '/seller/tambah-stokis',
					// 	show: true,
					// },
					// {
					// 	title: 'Request Order',
					// 	to: '/seller/request-order',
					// 	show: true,
					// },
					// {
					// 	title: 'Klaim Order',
					// 	to: '/seller/klaim-order',
					// 	show: true,
					// }
				]
			},
			{
				icon: '/assets/seller/penghasilanmu.svg',
				title: 'Saldo',
				to: '/seller/saldo',
				access: ['general'],
				children: []
			},
			{
				icon: '/assets/seller/inbox.svg',
				title: 'Inbox',
				to: '/seller/inbox',
				access: ['general'],
				children: []
			},
			// {
			// 	icon: '/assets/seller/penghasilanmu.svg',
			// 	title: 'Penghasilan',
			// 	to: '/seller',
			// 	children: [
			// 	{
			// 		title: 'Penghasilan Saya',
			// 		to: '/seller/penghasilan-saya',
			// 		show: true,
			// 	},
			// 	{
			// 		title: 'Rekening Bank',
			// 		to: '/seller/rekening-bank',
			// 		show: true,
			// 	}
			// 	]
			// },
			{
				icon: '/assets/seller/pengaturan.svg',
				title: 'Pengaturan',
				to: '/seller',
				access: ['general'],
				children: [
					{
						title: 'Profil Toko',
						to: '/seller/profile-toko',
						show: true,
					},
					{
						title: 'Jasa Pengiriman',
						to: '/seller/pengaturan-pengiriman',
						show: true,
					},
					// {
					// 	title: 'Rekening Bank',
					// 	to: '/seller/rekening-bank',
					// 	show: true,
					// },
					// {
					// 	title: 'Pencarian Otomatis',
					// 	to: '/seller/pencarian-otomatis',
					// 	show: true,
					// }
				]
			}
			]
			return items
		}
	},

	watch: {
		sellerData(val) {
			if (val) {
				// this.userType = (val.store_is_dropshipper == 'Ya' && val.store_is_dropship == 'Tidak') ? 'dropshipper' : 'dropship'
				if (val.store_is_dropshipper == 'Tidak' && val.store_is_dropship == 'Tidak' && val.store_is_seller == 'Ya') this.userType = 'seller'
				else if (val.store_is_dropshipper == 'Ya' && val.store_is_dropship == 'Tidak') this.userType = 'dropshipper'
				else if (val.store_is_dropshipper == 'Tidak' && val.store_is_dropship == 'Ya') this.userType = 'dropship'
				else this.userType = 'seller'
			}
		}
	},

	methods: {
		...mapActions('storeSeller', ['getStoreDetail']),
		...mapActions('messages', ['getAllMessageSeller']),

		gotoModule(link) {
			this.$router.push({ path : link})
		},

		checkPermission(url) {
			const restrictUrl = ['Produk Eksklusif', 'Order Produk Eksklusif']
			const check = restrictUrl.filter(d => d === url)
			if (check.length && this.sellerData.user_type !== 'stockist') return 'd-none'
			else return ''
		},

		filterUnreadMsg(lists) {
			let dataList = []
			if (lists.length > 0) {
				dataList = lists.filter((msg) => (msg.message_status == 'Terkirim'))
			}

			return dataList
		}
	},

	mounted() {
		/*this.getStoreDetail()*/
		this.getAllMessageSeller()
		this.activeUrl = window.location.pathname
		if (this.sellerData && Object.keys(this.sellerData).length > 0) {
			const val = this.sellerData
			if (val.store_is_dropshipper == 'Tidak' && val.store_is_dropship == 'Tidak' && val.store_is_seller == 'Ya') this.userType = 'seller'
			else if (val.store_is_dropshipper == 'Ya' && val.store_is_dropship == 'Tidak') this.userType = 'dropshipper'
			else if (val.store_is_dropshipper == 'Tidak' && val.store_is_dropship == 'Ya') this.userType = 'dropship'
			else this.userType = 'seller'
		}
	},
}
</script>

<style lang="scss" scoped>
#feature-items {
	height: 100vh;
	top: 90px;
	max-height: calc(100% - 0px);
	transform: translateX(0%);
	width: 260px;
	position: fixed;
	overflow-y: auto;
	padding-bottom: 15vh;
	box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.1), 0px 8px 10px 1px rgba(0, 0, 0, 0.05), 0px 3px 14px 2px rgba(0, 0, 0, 0.05)!important;

	@media (max-width: 599px) {
		display: none!important;
	}

	.feature-title {
		padding-left: 45px!important;
		position: relative;
		text-transform: capitalize!important;

		.v-image {
			position: absolute;
			width: 36px!important;
			height: 36px;
			left: -2px;
		}

		&.single-link {
			padding: 21px 12px;
			display: flex;
			position: relative;
			width: 100%;
			flex-direction: column;
			justify-content: center;
			text-decoration: none;
			color: #333;
			border-top: 1px solid rgba(0, 0, 0, 0.12);

			&:first-child {
				border-top: 0;
			}

			&:hover, &focus {
				background: #f5f5f5 !important;
			}
		}
	}
	.feature-item {
		padding-left: 45px!important;
		position: relative;
		text-transform: capitalize!important;
	}
}
</style>
